/* eslint-disable @next/next/no-img-element */
import { Editor } from '@tinymce/tinymce-react';
import { isEmpty } from 'lodash';
import { useState, useRef, useEffect } from "react";

export default function EditorComponent({ content: contentParent, editorId, onChangeContent }) {
    const [content, setContent] = useState(contentParent || '');
    // const [initContent, setInitContent] = useState(contentParent || '');

    // useEffect(() => {
    //     if( isEmpty(contentParent) ) return;
    //     setInitContent(contentParent);
    // }, [contentParent]);
    console.log('ssss');
    useEffect(() => {
        if( isEmpty(contentParent) ) return;
        setContent(contentParent);
    }, [contentParent]);

    //Update trạng thái của Parent khi update nội dung
    useEffect(() => {
        onChangeContent(editorId, content);
    }, [content]);

    const editorConfig = {
        height: 200,
        menubar: false,
        plugins: [
            'advlist autolink lists link charmap print anchor',
            'searchreplace visualblocks',
            'media table paste code help'
        ],
        toolbar: [
            'formatselect | bold italic underline | media link | forecolor | alignleft aligncenter alignright alignfull | numlist bullist outdent indent',
        ],
        placeholder: 'Nhập nội dung...',
        readonly: false
    };

    return <Editor
        inline={true}
        apiKey="z1rrokika57ohkkqom3i17q14g1hafud4xugg537tfw6x7xk"
        init={editorConfig}
        onEditorChange={(newValue, editor) => {
            setContent(newValue);
        }}
        // initialValue={initContent}
        value={content}
    />;
}
